var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJobSites(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 16,
    fill: "#6A00FF",
    fillOpacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0002 13.9062C25.498 13.9062 20.208 19.2944 20.208 25.9173C20.208 31.2765 23.5313 36.0785 26.3189 39.1629C28.8815 41.9992 31.2794 43.7397 31.3803 43.8123L32.0002 44.2594L32.6202 43.8127C32.7211 43.74 35.1187 41.9996 37.6815 39.1634C40.4692 36.0788 43.7925 31.2769 43.7925 25.9177C43.7925 19.2944 38.5025 13.9062 32.0002 13.9062ZM32.0002 31.8448C28.7856 31.8448 26.1704 29.1858 26.1704 25.9175C26.1704 22.6492 28.7856 19.9903 32.0002 19.9903C35.2148 19.9903 37.8301 22.6492 37.8301 25.9175C37.8301 29.1858 35.2148 31.8448 32.0002 31.8448Z",
    fill: "#6A00FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0227 43.5024C45.0227 45.4194 43.5591 47.1518 40.9024 48.3798C38.5076 49.4867 35.3458 50.0962 32.0001 50.0962C28.6544 50.0962 25.4926 49.4867 23.0978 48.3798C20.4411 47.1518 18.9775 45.4194 18.9775 43.5024C18.9775 41.5664 20.491 39.8334 23.1016 38.625C23.652 39.3337 24.2085 39.9886 24.7461 40.5837C27.4604 43.588 30.0323 45.4535 30.1406 45.5315L32.0001 46.8724L33.8596 45.5315C33.9679 45.4535 36.5398 43.588 39.2541 40.5837C39.7917 39.9886 40.3482 39.3337 40.8986 38.625C43.5092 39.8334 45.0227 41.5664 45.0227 43.5024Z",
    fill: "#6A00FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobSites);
export default __webpack_public_path__ + "static/media/job-sites.d7bb44b6704651d7d2ec6ad87ae7b080.svg";
export { ForwardRef as ReactComponent };